import { Fragment } from "react";
import { notifyError } from "../../../utils/notify";
import classes from "./NotifyCustom.module.css";

const { first_line } = classes;

export const NotifyErrorCustomBase = (msg = "Error", id_any) => {
  return (
    <div>
      {id_any ? (
        <Fragment>
          <span className={first_line}>{id_any}</span>
        </Fragment>
      ) : (
        <></>
      )}
      <span className="second-line">{msg}</span>
    </div>
  );
};

export const notifyErrorCustom = (
  msg = "Error",
  id_any,
  autoClose = 5000,
  otherOptions = {}
) => {
  notifyError(NotifyErrorCustomBase(msg, id_any), autoClose, otherOptions);
};
